import { useEffect, useState } from "react";

// FAZ F — Pencere düzeni köprüsü. Görevler paneli (TasksPanel) mount olduğunda
// kendi toplama/uygulama fonksiyonlarını buraya kaydeder; böylece 6 arayüzün
// üst barındaki DÜZENLER menüsü aynı mantığı kullanır (kopya mantık yok).
let impl = null;
const subs = new Set();

export const registerLayoutBridge = (o) => {
  impl = o;
  subs.forEach((f) => f(o));
  return () => {
    if (impl === o) {
      impl = null;
      subs.forEach((f) => f(null));
    }
  };
};

export const useLayoutBridge = () => {
  const [v, setV] = useState(impl);
  useEffect(() => {
    subs.add(setV);
    setV(impl);
    return () => subs.delete(setV);
  }, []);
  return v;
};
